import React, { useState, useCallback } from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import InputItem from "../atoms/InputItem";
import Paragraph from "../atoms/Paragraph";
import Button from "../atoms/Button";
import ArrowRight from "../atoms/icons/ArrowRight";
import InputTextArea from "../atoms/InputTextArea";
import { useSelector } from "react-redux";
import { sendPaymentProve } from "../../services/contactService";
import FileUploader from "../molecules/FileUploader";
import ErrorNotice from "../atoms/ErrorNotice";
import { useTranslation } from "react-i18next";

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 20px;
`;

const StyledErrorNotice = styled(ErrorNotice)`
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledArrowRight = styled(ArrowRight)`
  width: 15px;
  height: 11px;
  fill: white;
`;

const StyledTitle = styled.span`
  display: block;
  color: ${props => props.theme.tertiary};
  font-weight: 700;
  margin-bottom: 10px;
`;

const StyledFileUploaderWrapper = styled.div`
  margin-bottom: 20px;
`;

const PaymentProveModal = ({ onRequestClose }) => {
  const { t } = useTranslation(["common", "dossier"]);
  const { dossier } = useSelector(state => state.data);

  const [questionState, setQuestionState] = useState({
    dossier: dossier.number,
    client_name: dossier.debtor.salutation,
    question: "",
    email: "",
    telephone: "",
    files: {},
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const submit = e => {
    setLoading(true);
    setErrors({});
    e.preventDefault();

    const formData = new FormData();

    for (let i = 0; i < questionState.files.length; i++) {
      formData.append("files[]", questionState.files[i]);
    }

    Object.keys(questionState).forEach(
      key => key !== "files" && formData.append(key, questionState[key])
    );

    sendPaymentProve(formData)
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(err => {
        setLoading(false);
        setErrors(err.errors);
      });
  };

  const handleChange = e => {
    setQuestionState({ ...questionState, [e.target.name]: e.target.value });
  };

  const handleFileChange = useCallback(
    files => {
      setQuestionState({ ...questionState, files });
    },
    [questionState, setQuestionState]
  );

  return (
    <>
      {!success ? (
        <>
          <StyledParagraph>
            {t("dossier:payment_proof.introduction")}
          </StyledParagraph>
          {errors.generic_error && (
            <StyledErrorNotice>{errors.generic_error}</StyledErrorNotice>
          )}
          <form onSubmit={submit} encType="multipart/form-data">
            <InputItem
              name="email"
              disabled={loading}
              type="email"
              floatingLabel
              error={errors["email"]}
              label={t("dossier:payment_proof.email")}
              onChange={handleChange}
            />

            <InputItem
              error={errors["telephone"]}
              name="telephone"
              disabled={loading}
              floatingLabel
              label={t("dossier:payment_proof.phone_number")}
              onChange={handleChange}
            />
            <InputTextArea
              name="question"
              disabled={loading}
              floatingLabel
              label={t("dossier:payment_proof.remarks")}
              error={errors["question"]}
              onChange={handleChange}
            />

            <StyledTitle>{t("dossier:payment_proof.file")}</StyledTitle>
            <StyledFileUploaderWrapper>
              <FileUploader
                error={errors["files.0"]}
                disabled={loading}
                onChange={handleFileChange}
                required
              />
            </StyledFileUploaderWrapper>
            <ButtonWrapper>
              <Button
                loading={loading ? 1 : 0}
                secondary
                reversed
                icon={<StyledArrowRight />}
              >
                {t("dossier:payment_proof.send")}
              </Button>
            </ButtonWrapper>
          </form>
        </>
      ) : (
        <>
          <StyledParagraph>{t("dossier:payment_proof.thank")}</StyledParagraph>
          <Button primary wide onClick={onRequestClose}>
            {t("generic.close")}
          </Button>
        </>
      )}
    </>
  );
};

export default PaymentProveModal;
